import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {SidenavTariff} from '../../../domain/sidenav-tariff';
import {SidenavService} from '../../../services/sidenav-service';
import {SupplyType} from '../../../domain/tariff-entity';

@Component({
  selector: 'app-supply-tariffs-view',
  templateUrl: './supply-tariffs-view.component.html',
  styleUrls: ['./supply-tariffs-view.component.css']
})
export class SupplyTariffsViewComponent implements OnInit, OnDestroy {
  loading: Observable<boolean>;
  sidenavSubscription: Subscription;
  tariffs: Array<SidenavTariff>;
  selectedTariff: SidenavTariff;

  constructor(
    private sidenavService: SidenavService,
    private route: ActivatedRoute) {}

  ngOnInit() {
    this.loading = this.sidenavService.isLoading();

    this.sidenavSubscription = this.sidenavService.getTariffs(SupplyType).subscribe( data => {
      this.tariffs = data;
      this.findSelectedTariff();
    } );
  }

  ngOnDestroy() {
    this.sidenavSubscription.unsubscribe();
  }

  private findSelectedTariff() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const code = params.get('code');
      for (const tariff of this.tariffs) {
        if (tariff.code === code) {
          this.selectedTariff = tariff;
        }
      }
    });
  }

}
